import { Selection, select } from "d3";
import "../../../styles/pages/ChatList.scss";
import { CHAT_GROUP_ID_PARAM, GroupChangeEvent, groupContext } from "../../context/group";
import { _APP_DATA } from "../../data/AppData";
import { EEventId, IAlumno } from "../../data/models/Entities";
import { _ALUMNOS_MAP } from "../../data/services/Alumno";
import { _CHAT_GRUPOALUMNO_MENSAJES_NOLEIDOS_MAP } from "../../data/services/Chat";
import { _ESCOLARIDAD_CONFIGURACION_MAP } from "../../data/services/Escolaridad";
import { _SvGrupoObtenerMaestrosInfo } from "../../data/services/Grupo";
import { _ID_CHAT_GROUP } from "../../data/utils/General";
import { HashEvent, _AddOnParamsChangeEventListener, _GetHashInfo, _HistoryBackEvalAndTry, _RemoveOnParamsChangeEventListener, _SetParams } from "../../routes/Router";
import { _HashReplace, _HistoryBack } from "../../routes/UIManager";
import _L from "../../utils/Labels";
import { BaseUI } from "../bases/BaseUI";
import { EmptyTag } from "../components/EmptyTag";
import { LOADING } from "../components/Loading";
import { ShowToast } from "../components/Toast";
import { _CreateElementFromHTML } from "../utils/General";
import { Chat } from "../views/Chat";
import ic_back from '/icons/ic_back.svg?raw';
import ic_background_chat from '/icons/ic_logo_teacher_chat.svg?raw';

import { AvatarAlumnoComponent } from "../components-lit/AvatarAlumno/AvatarAlumno";


const CHAT_CHILD_ID_PARAM = "chatchildid";
export class ChatList extends BaseUI {
    private infoChatSelected?: Selection<HTMLDivElement, any, any, any>;
    private chatContainer: Selection<HTMLDivElement, any, any, any>;
    private listChatsContainer: Selection<HTMLDivElement, any, any, any>;
    private messagesContainer: Selection<HTMLDivElement, any, any, any>;

    private childList: IAlumno[] = [];
    private childSelected: IAlumno;
    private clsChat: Chat | null = null;

    private emptyTag: EmptyTag;
    private isLoadingGroup: boolean = false;

    constructor() {
        super({
            addMainLogoOptions: false,
            addOptionsInHeader: false,
            monitorChat: true,
            className: 'ui-chat-list',
            requiresGroupChild: true,
            timmerLoadUnreadedChat: 15000,
        });
    }

    protected async ValidateViewPermission(): Promise<boolean> {
        if (!_ESCOLARIDAD_CONFIGURACION_MAP?.size) {
            await groupContext.getEscolaridadCfg(_APP_DATA.userData.IdNivel, false);
        }

        let itemChat = Array.from(_ESCOLARIDAD_CONFIGURACION_MAP.values()).filter(o => o.Tipo == EEventId.CHAT);
        !(itemChat.length > 0) && ShowToast(_L("general.non_available_view"), _L("general.no_config"), "warn");
        return itemChat.length > 0;
    }

    protected InitClass(): void | Promise<any> {
        this.EnsureExplicitGroupId();

        _SvGrupoObtenerMaestrosInfo();

        this.chatContainer = this.bodyContainer.append("div").classed("chat-container", true)
        this.listChatsContainer = this.chatContainer.append("div").classed("list-chat-child", true)

        this.RefreshChatsList();

        this.CreateHeaderChat();
        this.UpdateListChatsChild();

        this.messagesContainer = this.chatContainer.append("div").classed("chat-messages-container", true)
        this.CreateMessageContainer();

        this.UpdateViewByURLParams(undefined, true);

        const onchangeparams: ((e: HashEvent) => void) = (e) => {
            if (this.isLoadingGroup) return;
            this.UpdateViewByURLParams(e.detail.Params);
        }
        this["__onchangeparams"] = onchangeparams;
        _AddOnParamsChangeEventListener(onchangeparams);
    }

    private EnsureExplicitGroupId(URLParams?: URLSearchParams) {
        !URLParams && (URLParams = _GetHashInfo()?.Parmas);
        const urlGroupId = URLParams?.get(CHAT_GROUP_ID_PARAM);
        if (!urlGroupId) {
            _SetParams({
                [CHAT_GROUP_ID_PARAM]: _APP_DATA.userData.IdGrupo,
            }, false);
        }
    }

    private UpdateViewByURLParams(URLParams?: URLSearchParams, isFirstLoad: boolean = false) {
        !URLParams && (URLParams = _GetHashInfo()?.Parmas);
        this.EnsureExplicitGroupId(URLParams);
        const chatIdChild = URLParams?.get(CHAT_CHILD_ID_PARAM);
        if (!chatIdChild) {
            !isFirstLoad && this.DeselectChat();
            return;
        }
        this.SelectChildById(Number(chatIdChild));
    }

    protected async OnChangeGroup(e: GroupChangeEvent) {
        this.isLoadingGroup = true;
        LOADING.Show();
        await super.OnChangeGroup(e);
        LOADING.Dismiss();
        const viewValid = await this.ValidateViewPermission();
        if (!viewValid) {
            _HistoryBackEvalAndTry("default");
            this.isLoadingGroup = false;
            return;
        }
        this.DeselectChat();
        LOADING.Show();
        _SvGrupoObtenerMaestrosInfo();
        this.RefreshChatsList();
        this.UpdateListChatsChild();
        this.CreateMessageContainer();
        this.isLoadingGroup = false;
        LOADING.Dismiss();
        this.UpdateViewByURLParams()
    }

    protected OnChangeOnreadedMessage(): void {
        this.UpdateListChatsChild();
    }

    private SelectChildById(id: number) {
        let target = this.childList?.find(c => c.IdChild == id);

        if (!target && id !== _ID_CHAT_GROUP) {
            ShowToast("Información no disponible", "", "warn", "TOP-RIGHT");
            _HashReplace("#chat");
            this.DeselectChat();
            return;
        }

        if (id == _ID_CHAT_GROUP) {
            target = this.childList?.find(c => c.IdChild === _ID_CHAT_GROUP);
        }
        this.OnChatSelected(target);
        this.UpdateListChatsChildSelectedState();
    }

    private DeselectChat() {
        this.childSelected && (this.childSelected = null);
        if (this.clsChat) {
            this.clsChat.Destroy();
            this.clsChat = null;
        }
        this.childList && (this.childList = null);
        this.CreateHeaderChat();
        this.RefreshChatsList();
        this.UpdateListChatsChild();
        this.CreateMessageContainer();
    }

    private RefreshChatsList() {
        const objGroupCht: IAlumno = {
            IdChild: _ID_CHAT_GROUP,
            Nombre: _APP_DATA.userData.NombreGrupo,
            Sexo: _ID_CHAT_GROUP,//identificador grupo
            unreadMessages: 0
        } as any;
        this.childList = [objGroupCht, ..._ALUMNOS_MAP.values()];
    }

    private CreateHeaderChat() {
        this.topBarElement.remove();
        this.headerContainer.selectAll("*").remove();

        const headerChat = this.headerContainer.append("div").classed("header-chat", true);

        headerChat.append(() => _CreateElementFromHTML(ic_back))
            .attr("class", "back")
            .on("click", () => {
                _HistoryBack();
            });

        this.infoChatSelected = headerChat.append("div").classed("info-chat", true);
        this.infoChatSelected.append("h3");
        const bbleCont = this.infoChatSelected.append("div").classed("bble-container", true)
        const alumnoSeleccionadoAvatar = new AvatarAlumnoComponent();
        alumnoSeleccionadoAvatar.className = "prof-child child-in-header-chat";
        alumnoSeleccionadoAvatar.k_width = "100%";
        alumnoSeleccionadoAvatar.k_height = "100%";
        alumnoSeleccionadoAvatar.k_altNameMode = "short";
        bbleCont.node().appendChild(alumnoSeleccionadoAvatar);
        this.infoChatSelected.style("visibility", "hidden")
    }

    private CreateMessageContainer() {
        this.emptyTag?._Remove();
        //Agregar fondo de chat mientras no se ha seleccionado ningun niño
        this.emptyTag = new EmptyTag(this.messagesContainer.node())
            ._SetText(_L("chat.focuschat"))
            ._SetSVGIcon(ic_background_chat, { width: "var(--default-hgt-img-background)", opacity: .5 })
            ._SetColor("var(--color-orange)")
            ._ShowTag()
    }

    private UpdateListChatsChildSelectedState() {
        this.listChatsContainer.selectAll<HTMLDivElement, any>(".bubbles-child")
            .each((datum, i, divs) => {
                const elemnt = select(divs[i]);
                const isSelected = this.childSelected?.IdChild == datum.IdChild;
                elemnt.classed("selected", isSelected);
                if (isSelected) {
                    elemnt.node().scrollIntoView({ behavior: "smooth", block: "nearest" });
                }
            });
    }

    private UpdateListChatsChild() {
        if (!this.listChatsContainer?.node()) return;
        const bubblesChild = this.listChatsContainer.selectAll<HTMLDivElement, any>(".bubbles-child").data(this.childList);

        // const self = this;
        bubblesChild.exit().remove();
        bubblesChild.enter().append("div")
            .classed("bubbles-child", true)
            .each((_, i, divs) => {
                const alumnoAvatar = new AvatarAlumnoComponent();
                alumnoAvatar.k_width = "var(--sze-bubble-child)";
                alumnoAvatar.k_height = "var(--sze-bubble-child)";
                alumnoAvatar.k_altNameMode = "full";
                alumnoAvatar.k_minBorderWidth = 1;
                alumnoAvatar.k_maxBorderWidth = 2;
                alumnoAvatar.className = "prof-child child-in-list-chat";

                divs[i].appendChild(alumnoAvatar);

                select(alumnoAvatar).append("span")
                    .classed("num-messages", true)
            })
            .merge(bubblesChild)
            .on('click', function (_, datum) {
                _SetParams({
                    [CHAT_CHILD_ID_PARAM]: datum.IdChild,
                }, false)
            })
            .each((datum, i, divs) => {
                const elemnt = select(divs[i]);
                const esGrupo = datum.Sexo == _ID_CHAT_GROUP;

                const alumnoAvatar = elemnt.select(".prof-child.child-in-list-chat").node() as AvatarAlumnoComponent;
                alumnoAvatar.k_alumno = datum;
                alumnoAvatar.k_colorBorder = esGrupo ? "var(--color-orange)" : null;

                select(alumnoAvatar).classed("group", esGrupo);

                const nMsg = _CHAT_GRUPOALUMNO_MENSAJES_NOLEIDOS_MAP.get(_APP_DATA.userData.IdGrupo)?.get(datum.IdChild)?.size || 0;
                select(alumnoAvatar).select(".num-messages")
                    .classed("active", nMsg > 0)
                    .text(nMsg);
            });
    }

    private OnChatSelected(datum: IAlumno) {
        if (this.childSelected && this.childSelected.IdChild != datum.IdChild && this.clsChat) {
            this.clsChat.Destroy();
            this.clsChat = null;
        }

        this.childSelected = datum;

        //Mostrar info del niño/grupo seleccionado
        this.infoChatSelected?.style("visibility", "visible");
        this.infoChatSelected?.select("h3").text(datum.Nombre);

        const alumnoSeleccionadoAvatar = this.infoChatSelected?.select(".prof-child.child-in-header-chat").node() as AvatarAlumnoComponent;
        alumnoSeleccionadoAvatar.k_alumno = datum;
        const esGrupo = datum.Sexo == _ID_CHAT_GROUP;
        alumnoSeleccionadoAvatar.k_colorBorder = esGrupo ? "var(--color-orange)" : null;
        setTimeout(() => {
            alumnoSeleccionadoAvatar.requestUpdate();
        }, 100);

        if (!this.clsChat) {
            this.clsChat = new Chat(this.messagesContainer, this.childSelected);
            this.clsChat.OnUpdateUnreaded(() => {
                this.UpdateListChatsChild();
            });
        }
        // else
        //     this.clsChat._UpdateChatChild(this.childSelected)

        //Eliminar fondo de pantalla
        this.emptyTag?._Remove();
    }

    public OnDestroy(): void {
        super.OnDestroy();

        if (this.clsChat) {
            this.clsChat.Destroy();
            this.clsChat = null;
        }

        if (this["__onchangeparams"]) {
            _RemoveOnParamsChangeEventListener(this["__onchangeparams"]);
        }
    }
}